import React, { ComponentProps } from 'react';
import { Select } from 'antd';
import { useQuery } from '@common/hooks';
import { ErrorHandler } from '@common/components';
import { WorksMembershipRolesQuery } from 'works/legacy/graphql/works-membership-roles';
import { selectInputFilterHelper } from '@common/services';

type Props = ComponentProps<typeof Select>;

export function WorksMembershipRoleSelect(props: Props) {
  const { loading, error, data } = useQuery(WorksMembershipRolesQuery);

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="WorksMembershipRoleSelect"
        messageType="contextual"
      />
    );
  }

  return (
    <Select
      size="large"
      showSearch
      loading={loading}
      getPopupContainer={(trigger) => trigger.parentNode}
      filterOption={(input, option) =>
        selectInputFilterHelper(input, { children: option?.children })
      }
      {...props}
    >
      {data?.worksMembershipRoles?.map(
        ({ text, value }: { text: string; value: string }) => (
          <Select.Option key={text} value={value}>
            {text}
          </Select.Option>
        )
      )}
    </Select>
  );
}
